export default {
  title: 'Insurance company formats',
  subtitle: 'Select the format you need from the list below.',
  purpose: 'These documents are provided by the insurer for different processes related to your policy.'
}
